import { benefits, howItWorksSteps } from "@/content/coletor-publico-landing";

export default function ProcessSection() {
  return (
    <section className="bg-white">
      {/* Benefícios */}
      <div id="relatorios" className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              Benefícios
            </h2>
            <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
              FloraIQ entrega valor técnico, operacional e estratégico para gestão do patrimônio verde urbano.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {benefits.map((b) => (
              <div
                key={b.title}
                className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300/60 transition-colors"
              >
                <div className="w-8 h-8 rounded-lg bg-primary-50 flex items-center justify-center mb-3">
                  <i className="ri-check-line text-primary-600 text-sm w-full h-full flex items-center justify-center" />
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1.5">
                  {b.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  {b.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Como funciona */}
      <div className="border-t border-background-200/70 py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              Como funciona
            </h2>
            <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
              Um fluxo simples e estruturado do cadastro ao relatório final.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-4 md:gap-3">
            {howItWorksSteps.map((s, idx) => (
              <div key={s.step} className="relative">
                <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 h-full">
                  <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center mb-3">
                    <i className={`${s.icon} text-white text-lg w-full h-full flex items-center justify-center`} />
                  </div>
                  <div className="text-xs font-semibold text-primary-600 mb-1">
                    Etapa {s.step}
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1.5">
                    {s.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    {s.description}
                  </p>
                </div>
                {idx < howItWorksSteps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-2 z-10">
                    <i className="ri-arrow-right-line text-background-300 w-4 h-4 flex items-center justify-center" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}